import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.menuInitialRecommendationList = [];
};

const recommendationListSuccess = (state, menuInitialRecommendationList) => {
  state.menuInitialRecommendationList = menuInitialRecommendationList;
};

const createInitialRecommendationSuccess = (state, payload) => {
  state.menuInitialRecommendationList.push(payload);
};

const editInitialRecommendationListSuccess = (state, payload) => {
  const foundIndex = state.menuInitialRecommendationList.findIndex((recommendation) => recommendation.guid === payload.guid);
  state.menuInitialRecommendationList[foundIndex] = payload;
};

const removeRecommendationListSuccess = (state, payload) => {
  state.menuInitialRecommendationList = state.menuInitialRecommendationList.filter(((recommendation) => recommendation.guid !== payload.guid));
};

export const mutations = {
  [MutationTypes.INITIAL_RECOMMENDATION_LIST_SUCCESS]: recommendationListSuccess,
  [MutationTypes.CREATE_INITIAL_RECOMMENDATION_SUCCESS]: createInitialRecommendationSuccess,
  [MutationTypes.EDIT_INITIAL_RECOMMENDATION_SUCCESS]: editInitialRecommendationListSuccess,
  [MutationTypes.DELETE_INITIAL_RECOMMENDATION_SUCCESS]: removeRecommendationListSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
